export const pxToNumber = (px: string) => Number(px.replace('px', ''))
